import { Button, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory } from "react-router-dom";
import consts from "../../../main/consts";

const useStyles = makeStyles(() => ({
	toast: {
		display: "flex",
		alignItems: "flex-start",
		width: 664,
		maxWidth: "90vw",
		padding: "6px 16px",
		boxSizing: "border-box",
		borderRadius: 4,
		backgroundColor: "#FFCA3A",
		boxShadow:
			"0 1px 8px 0 rgba(0, 0, 0, 0.06), 0 3px 4px 0 rgba(0, 0, 0, 0.07), 0 3px 3px -2px rgba(0, 0, 0, 0.10)",
	},
	icon: {
		display: "flex",
		width: 22,
		height: 22,
		fontSize: 22,
		color: "#000000",
		marginRight: 12,
		padding: "7px 0",
		boxSizing: "content-box",
	},
	containerTexto: {
		display: "flex",
		flexDirection: "column",
		flex: "1 1 0",
		minWidth: 0,
		padding: "8px 0",
	},
	titulo: {
		alignSelf: "stretch",
		color: "#000000",
		fontSize: 16,
		fontWeight: 700,
		lineHeight: "150%",
		letterSpacing: "0.15px",
		fontFeatureSettings: "'liga' off, 'clig' off",
	},
	subtitulo: {
		color: "#000000",
		fontSize: 14,
		fontWeight: 500,
		lineHeight: "143%",
		letterSpacing: "0.15px",
		fontFeatureSettings: "'liga' off, 'clig' off",
	},
	containerAcoes: {
		display: "flex",
		alignItems: "center",
		marginLeft: 16,
		padding: "8px 0",
	},
	acao: {
		color: "rgba(26, 26, 26, 0.87)",
		fontSize: 14,
		fontWeight: 700,
		letterSpacing: "0.4px",
		whiteSpace: "nowrap",
		padding: "0 8px",
	},
	fechar: {
		color: "#000000",
		marginLeft: 8,
		padding: 4,
	},
}));

const AlertaPedidosPendentes = React.forwardRef(function AlertaPedidosPendentes(
	{ id, minutos = 15, quantidade },
	ref,
) {
	const classes = useStyles();
	const history = useHistory();
	const { closeSnackbar } = useSnackbar();

	const irParaSeparacao = () => {
		history.push(`${consts.CONTEXT}/new-orders`);
		closeSnackbar(id);
	};

	return (
		<div ref={ref} className={classes.toast}>
			<ReportProblemOutlinedIcon className={classes.icon} />
			<div className={classes.containerTexto}>
				<Typography className={classes.titulo}>
					Atenção: pedidos aguardando confirmação
				</Typography>
				<Typography className={classes.subtitulo}>
					{quantidade ? `${quantidade} pedido(s)` : "Pedido(s)"} novo(s) sem
					movimentação há mais de {minutos} min.
				</Typography>
			</div>
			<div className={classes.containerAcoes}>
				<Button className={classes.acao} onClick={irParaSeparacao}>
					Iniciar separação
				</Button>
				<IconButton
					size="small"
					className={classes.fechar}
					onClick={() => closeSnackbar(id)}
				>
					<CloseIcon fontSize="small" />
				</IconButton>
			</div>
		</div>
	);
});

export default AlertaPedidosPendentes;
